/* PDP clone kit – bundle area (snippets/pdp-offers.liquid), used by the main product section and "ABC - Offers".
   Liquid renders the selected offer; this only reacts to clicks:
   - picking an offer (a radio inside its card) updates the price row, the button's price pill, the one-time link, the
     gifts that are unlocked and the product form's id / quantity / selling plan inputs, and (like the original) puts
     ?count=N in the address and shows the offer's gallery image on the first slide;
   - Add to cart: the form goes through the theme's own <product-form>, so the cart drawer opens as usual. Gift products
     the offer unlocks and the offer's discount code are added to the cart just before. With "Go to checkout", the items
     are added here and the shopper goes to checkout;
   - the one-time link adds the same offer without its selling plan, discount code or gifts;
   - the sold bar's label counts up while the bar fills (5 s, then nothing runs). */
(function () {
  'use strict';
  var PDP = window.PDP || {};
  var define = PDP.define || function (n, c) { if (window.customElements && !customElements.get(n)) customElements.define(n, c); };
  var reduce = !!PDP.reduceMotion;

  function post(url, body) {
    return fetch(String(url || '').replace(/\/$/, '') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  define('pdp-offers', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-offer]'));
      this.gifts = Array.prototype.slice.call(this.querySelectorAll('[data-unlock]'));
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.idInput = this.querySelector('[data-offer-id]');
      this.qtyInput = this.querySelector('[data-offer-qty]');
      this.planInput = this.querySelector('[data-offer-plan]');
      this.atc = this.querySelector('[data-atc]');
      this.otp = this.querySelector('[data-otp-link]');
      this.index = parseInt(this.dataset.selected, 10) || 1;
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('input[type="radio"][name^="pdp-offer-"]')) self.select(parseInt(t.value, 10), true);
      });
      // like the original, a click on the offer that is already selected still puts it in the address
      this.addEventListener('click', function (e) {
        var card = e.target.closest && e.target.closest('[data-offer]');
        if (card && self.cards.indexOf(card) + 1 === self.index) self.remember(self.index);
      });
      // a link with ?count=N opens with that offer selected (like the original)
      if (this.dataset.urlCount === 'true') {
        var n = parseInt(new URLSearchParams(location.search).get('count'), 10);
        if (n && this.cards[n - 1] && n !== this.index) {
          var r = this.cards[n - 1].querySelector('input[type="radio"]');
          if (r) r.checked = true;
          this.select(n, false);
        }
      }
      if (this.atc) this.atc.addEventListener('click', function (e) { self.add(e, false); }, true);
      if (this.otp) this.otp.addEventListener('click', function (e) { self.add(e, true); });
      this.syncLabel();
      this.countSold();
      this.localDate();
      // the theme's variant picker (products with several variants): offers that follow it get new prices
      var main = this.closest('pdp-main');
      if (main && this.cards.length) {
        main.addEventListener('change', function (e) {
          if (!e.target.closest || !e.target.closest('variant-selects, variant-radios, .pdp-variants')) return;
          setTimeout(function () { self.refresh(); }, 60);
        });
      }
    }

    card() { return this.cards[this.index - 1] || null; }

    setAll(sel, text, hideEmpty) {
      this.querySelectorAll(sel).forEach(function (el) {
        if (hideEmpty) el.hidden = !text;
        if (text != null && el.textContent !== text) el.textContent = text;
      });
    }

    select(n, byShopper) {
      var card = this.cards[n - 1];
      if (!card) return;
      this.index = n;
      var d = card.dataset;
      this.setAll('[data-sel-price]', d.price);
      this.setAll('[data-sel-compare]', d.compare, true);
      this.setAll('[data-sel-savings]', d.savings);
      this.setAll('[data-sel-otp]', d.otpPrice);
      if (this.idInput) this.idInput.value = d.variant;
      if (this.qtyInput) this.qtyInput.value = d.qty;
      if (this.planInput) this.planInput.value = d.plan || '';
      if (this.atc) {
        var ok = d.available === 'true';
        this.atc.disabled = !ok;
        var label = this.atc.querySelector('.pdp-atc__label');
        if (label) label.textContent = ok ? this.atc.dataset.label : this.atc.dataset.soldout;
      }
      this.gifts.forEach(function (g) { g.classList.toggle('is-locked', (parseInt(g.dataset.unlock, 10) || 1) > n); });
      if (byShopper) this.remember(n);
      if (byShopper) this.showGalleryImage(d.gallery || '');
    }

    // ?count=N in the address (a link with it opens with that offer selected)
    remember(n) {
      if (this.dataset.urlCount !== 'true' || !window.history || !history.replaceState) return;
      try {
        var u = new URL(location.href);
        if (u.searchParams.get('count') === String(n)) return;
        u.searchParams.set('count', String(n));
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) { /* ignore */ }
    }

    // like the original: picking an offer shows its image on the gallery's first slide and goes back to that slide
    showGalleryImage(src) {
      var main = this.closest('pdp-main');
      var g = main && main.querySelector('pdp-gallery');
      if (!g) return;
      var img = g.querySelector('.pdp-gallery__slide img');
      var thumb = g.querySelector('.pdp-gallery__thumb img');
      [img, thumb].forEach(function (el) {
        if (!el) return;
        if (el.dataset.origSrc == null) { el.dataset.origSrc = el.getAttribute('src') || ''; el.dataset.origSrcset = el.getAttribute('srcset') || ''; }
        if (src) { el.removeAttribute('srcset'); el.setAttribute('src', src); }
        else { el.setAttribute('src', el.dataset.origSrc); if (el.dataset.origSrcset) el.setAttribute('srcset', el.dataset.origSrcset); }
      });
      if (g.goTo) g.goTo(0);
    }

    unlockedGifts() {
      var n = this.index;
      return this.gifts.filter(function (g) { return g.dataset.giftVariant && (parseInt(g.dataset.unlock, 10) || 1) <= n; })
        .map(function (g) { return { id: parseInt(g.dataset.giftVariant, 10), quantity: 1 }; });
    }

    busy(on) {
      [this.atc, this.otp].forEach(function (b) { if (b) { b.setAttribute('aria-disabled', on ? 'true' : 'false'); b.classList.toggle('is-busy', on); } });
    }

    add(e, oneTime) {
      if (this._sending) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var card = this.card();
      if (!this.form || !this.atc) return;
      if (this.atc.disabled && !oneTime) return;
      var self = this;
      var checkout = this.dataset.after === 'checkout';
      var gifts = oneTime ? [] : this.unlockedGifts();
      var code = oneTime || !card ? '' : (card.dataset.code || '');
      var plan = this.planInput ? this.planInput.value : '';
      // the plain case: the theme's product form does it all (the click goes on as usual)
      if (!oneTime && !checkout && !gifts.length && !code) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this._sending = true;
      this.busy(true);
      var done = function () { self._sending = false; self.busy(false); };
      if (checkout) {
        var item = { id: parseInt(card ? card.dataset.variant : this.idInput.value, 10), quantity: parseInt(card ? card.dataset.qty : this.qtyInput.value, 10) || 1 };
        if (!oneTime && plan) item.selling_plan = parseInt(plan, 10);
        post(this.dataset.cartAdd, { items: [item].concat(gifts) })
          .then(function () { return code ? post(self.dataset.cartUpdate, { discount: code }).catch(function () {}) : null; })
          .then(function () { window.location.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); })
          .catch(function () { done(); self.form.requestSubmit(self.atc); });
        return;
      }
      var chain = Promise.resolve();
      if (gifts.length) chain = chain.then(function () { return post(self.dataset.cartAdd, { items: gifts }); });
      if (code) chain = chain.then(function () { return post(self.dataset.cartUpdate, { discount: code }); });
      var submit = function () {
        done();
        if (oneTime && self.planInput) self.planInput.value = '';
        self.form.requestSubmit(self.atc);           // the theme's product form reads the form right away
        if (oneTime && self.planInput) self.planInput.value = plan;
      };
      chain.then(submit, submit);
    }

    // Shrine writes its own "Add to cart" / "Sold out" into the label when a variant changes; the block's labels win
    syncLabel() {
      var self = this;
      var label = this.atc && this.atc.querySelector('.pdp-atc__label');
      if (!label || !window.MutationObserver) return;
      new MutationObserver(function () {
        var s = window.variantStrings || {};
        var t = label.textContent.trim();
        var want = t === s.addToCart ? self.atc.dataset.label : t === s.soldOut ? self.atc.dataset.soldout : t;
        if (want && want !== t) label.textContent = want;
      }).observe(label, { childList: true, characterData: true, subtree: true });
    }

    countSold() {
      var bar = this.querySelector('[data-sold]');
      var lab = bar && bar.querySelector('[data-sold-label]');
      if (!lab || reduce) return;
      var tpl = lab.dataset.soldLabel || '';
      var target = parseInt(bar.dataset.sold, 10) || 0;
      if (tpl.indexOf('[percent]') < 0) return;
      // the count eases out over 5 s (cubic). A timer wakes up only when the shown whole number changes, so no
      // frame runs while it stays the same (most of the 5 s near the end)
      var t0 = performance.now(), shown = 0;
      var show = function (n) { lab.textContent = tpl.split('[percent]').join(String(n)); };
      var next = function () {
        var spent = performance.now() - t0;
        var n = Math.round(target * (1 - Math.pow(1 - Math.min(1, spent / 5000), 3)));
        if (n !== shown) { shown = n; show(n); }
        if (shown >= target) return;
        var at = (1 - Math.pow(1 - Math.min(1, (shown + 0.5) / target), 1 / 3)) * 5000;   // when the next number is due
        setTimeout(next, Math.max(16, at - spent));
      };
      show(0);
      next();
    }

    // the date Liquid rendered is the store's; the shopper's own calendar day can differ around midnight
    localDate() {
      this.querySelectorAll('[data-ship-days]').forEach(function (el) {
        var d = new Date();
        d.setDate(d.getDate() + (parseInt(el.dataset.shipDays, 10) || 0));
        var t = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        if (t && el.textContent !== t) el.textContent = t;
      });
    }

    // a new variant from the theme's picker: offers that follow it re-render with its prices
    refresh() {
      var self = this;
      var id = this.form && this.form.querySelector('[name="id"]') && this.form.querySelector('[name="id"]').value;
      if (!id || id === this._lastVariant) return;
      this._lastVariant = id;
      var url = location.pathname + '?variant=' + encodeURIComponent(id) + '&section_id=' + encodeURIComponent(this.dataset.section);
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('pdp-offers[data-section="' + self.dataset.section + '"] .pdp-offers__list');
        var list = self.querySelector('.pdp-offers__list');
        if (!fresh || !list) return;
        var keep = self.index;
        list.innerHTML = fresh.innerHTML;
        self.cards = Array.prototype.slice.call(self.querySelectorAll('[data-offer]'));
        var r = self.cards[keep - 1] && self.cards[keep - 1].querySelector('input[type="radio"]');
        if (r) r.checked = true;
        self.select(keep, false);
      }).catch(function () {});
    }
  });
})();
